import { useState } from 'react'
import Select, { MenuListProps } from 'react-select'
import useInit from './hooks/useInit'
import getRows from './utils/getRows'
import useCustomerChange from './hooks/useCustomerChange'
import { selectClassNames } from 'shared/assets/conf'
import PerfectScrollbar from 'react-perfect-scrollbar'
import 'react-perfect-scrollbar/dist/css/styles.css'

interface HeaderCustomerSelectProps {
  setShowOverlay?: Function
  handleCustomerChanged?: Function
  customerName: any
}

const HeaderCustomerSelect: React.FunctionComponent<HeaderCustomerSelectProps> = (
  props: HeaderCustomerSelectProps,
) => {
  const [rows, setRows] = useState<any>([])
  const [dataLoaded, setDataLoaded] = useState<boolean>(false)
  const [initialRender, setInitialRender] = useState<boolean>(true)
  const [currentCustomer, setCurrentCustomer] = useState<{} | null>(null)

  useInit({
    getRows,
    setRows,
    setCurrentCustomer,
    setDataLoaded,
    customerName: props.customerName.name,
  })

  useCustomerChange({
    currentCustomer,
    initialRender,
    dataLoaded,
    setInitialRender,
    handleCustomerChanged: props.handleCustomerChanged,
  })

  const handleCustomerChange = (value) => {
    if (currentCustomer !== value) {
      if (props.setShowOverlay !== undefined) {
        props.setShowOverlay(true)
      }
      setCurrentCustomer(value)
    }
  }

  if (currentCustomer === null) {
    handleCustomerChange(rows[0])
  }

  const MenuList = (
    props: MenuListProps<any, false, any>
  ) => {
    return (
      <div>
        <PerfectScrollbar style={{background: 'transparent'}}>
          {props.children}
        </PerfectScrollbar>
      </div>
    );
  };

  return (
    <>
      {dataLoaded && (
        <>
          <label>Showing</label>
          <Select
            classNames={selectClassNames}
            components={{ MenuList }}
            options={rows}
            defaultValue={currentCustomer}
            getOptionLabel={(option) => option.name}
            getOptionValue={(option) => option.id}
            isClearable={false}
            onChange={(value) => handleCustomerChange(value)}
          />
        </>
      )}
      {!dataLoaded && (
        <>
          <label>Showing</label>
          <Select
            classNames={selectClassNames}
            options={[
              {
                value: 0,
                label: props.customerName.name,
              },
            ]}
            defaultValue={{
              value: 0,
              label: props.customerName.name,
            }}
          />
        </>
      )}
    </>
  )
}

export default HeaderCustomerSelect
